import React, { createContext, useContext, useState, useEffect } from "react";

const PermissionContext = createContext([]);

export const PermissionProvider = ({ children }) => {
  const [permissions, setPermissions] = useState(null);

  useEffect(() => {
    const stored = JSON.parse(sessionStorage.getItem("permissions")) || [];
    setPermissions(stored);
  }, []);

  if (permissions === null) return null;

  return (
    <PermissionContext.Provider value={{ permissions, setPermissions }}>
      {children}
    </PermissionContext.Provider>
  );
};

export const usePermissions = () => useContext(PermissionContext);
